import {
  IconAffiliate,
  IconAperture,
  IconAtom2,
  IconAtom,
  IconBrandChrome,
  IconBrandReactNative,
  IconBrandUbuntu,
  Icon3dCubeSphere,
  IconBallFootball,
  IconBiohazard,
  IconBox,
  IconBrandAirtable,
  IconBrandAppstore,
  IconBrandBing,
  IconBrandCodesandbox,
  IconBrandGoogleDrive,
  IconBrandHtml5,
  IconBrandLoom,
  IconBrandNetbeans,
  IconBrandSlack,
  IconBrandSublimeText,
  IconBrandVisualStudio,
  IconCash,
  IconCommand,
  IconComponents,
  IconCurrencyRipple,
  IconDiamond,
  IconDrone,
  IconVectorTriangle,
  IconSteeringWheel,
  IconSocial,
} from '@tabler/icons'

// 后端iconId为数字，所以定义为数组
export const ICON_MAP = [
  IconAffiliate,
  IconAperture,
  IconAtom2,
  IconAtom,
  IconBrandChrome,
  IconBrandReactNative,
  IconBrandUbuntu,
  Icon3dCubeSphere,
  IconBallFootball,
  IconBiohazard,
  IconBox,
  IconBrandAirtable,
  IconBrandAppstore,
  IconBrandBing,
  IconBrandCodesandbox,
  IconBrandGoogleDrive,
  IconBrandHtml5,
  IconBrandLoom,
  IconBrandNetbeans,
  IconBrandSlack,
  IconBrandSublimeText,
  IconBrandVisualStudio,
  IconCash,
  IconCommand,
  IconComponents,
  IconCurrencyRipple,
  IconDiamond,
  IconDrone,
  IconVectorTriangle,
  IconSteeringWheel,
  IconSocial,
]

export const ICON_LIST = Object.keys(ICON_MAP).map((key) => ({
  key,
  Icon: ICON_MAP[key],
}))
